import React, { useEffect, useState } from 'react';
import { OfferBar } from './components/OfferBar';
import { ProgressBar } from './components/ProgressBar';
import { HeroSection } from './components/HeroSection';
import { PainAgitation } from './components/PainAgitation';
import { FalseSolutions } from './components/FalseSolutions';
import { AuthorSection } from './components/AuthorSection';
import { MechanismReveal } from './components/MechanismReveal';
import { WeeklyBreakdown } from './components/WeeklyBreakdown';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { UrgencySection } from './components/UrgencySection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FaqSection } from './components/FaqSection';
import { FinalOfferSection } from './components/FinalOfferSection';
import { LegalModal } from './components/LegalModal';
import { SocialProofPopup } from './components/SocialProofPopup';
import { ViewersBar } from './components/ViewersBar';
import { initPixel, trackPageView } from './utils/pixel';
type ModalType = 'privacy' | 'terms' | null;
export function App() {
  const [legalModal, setLegalModal] = useState<ModalType>(null);
  useEffect(() => {
    initPixel();
    trackPageView();
  }, []);
  return <main className="min-h-screen bg-[#FAFAF5] font-sans text-[#2C1810] overflow-x-hidden pt-[45px]" data-id="element-0">
      <OfferBar data-id="element-1" />
      <ProgressBar data-id="element-2" />

      <HeroSection data-id="element-3" />
      <PainAgitation data-id="element-4" />
      <FalseSolutions data-id="element-5" />
      <AuthorSection data-id="element-6" />
      <MechanismReveal data-id="element-7" />
      <WeeklyBreakdown data-id="element-8" />
      <OfferSection id="comprar" showUrgency={true} showCountdown={true} showGuarantee={true} showPayment={true} data-id="element-9" />

      <TestimonialsSection data-id="element-10" />
      <GuaranteeSection data-id="element-11" />
      <UrgencySection data-id="element-12" />
      <FinalOfferSection data-id="element-13" />
      <FaqSection data-id="element-14" />

      <footer className="bg-[#2C1810] text-[#E8DFD0] text-center py-12 px-4 text-xs border-t border-[#5C4A3A]" data-id="element-15">
        <div className="max-w-4xl mx-auto space-y-6" data-id="element-16">
          <p className="font-serif text-lg text-[#FEFCF6]" data-id="element-17">Nutrikia Herbal</p>

          <div className="flex justify-center gap-6 flex-wrap text-[#8B7355]" data-id="element-18">
            <button onClick={() => setLegalModal('privacy')} className="hover:text-[#E8DFD0] transition-colors underline underline-offset-2" data-id="element-19">
              Política de Privacidad
            </button>
            <span className="text-[#5C4A3A]" data-id="element-20">|</span>
            <button onClick={() => setLegalModal('terms')} className="hover:text-[#E8DFD0] transition-colors underline underline-offset-2" data-id="element-21">
              Términos de Servicio
            </button>
          </div>

          <p className="mb-4 text-[#8B7355]" data-id="element-22">
            © 2025 Nutrikia Herbal. Todos los derechos reservados.
          </p>

          <p className="max-w-2xl mx-auto leading-relaxed text-[#5C4A3A]" data-id="element-23">
            Descargo de responsabilidad: Los resultados individuales pueden
            variar. Este producto no está diseñado para diagnosticar, tratar,
            curar o prevenir ninguna enfermedad. Consulta a tu médico antes de
            iniciar cualquier protocolo de salud natural.
          </p>
        </div>
      </footer>

      <LegalModal open={legalModal} onClose={() => setLegalModal(null)} data-id="element-24" />
      <SocialProofPopup data-id="element-25" />
      <ViewersBar data-id="element-26" />
    </main>;
}